import { faTimes, faUniversity } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Fragment, useEffect, useReducer, useRef, useState } from "react";
import { Alert, Button, Col, Form, FormGroup, Modal, Row } from "react-bootstrap";
import { useForm } from "react-hook-form";
import BihamtaTable from "../../Components/BihamtaTable";
import { CheckLg, DashCircle, ExclamationTriangle, Pencil, PencilFill, PlusSquareFill, Search } from "react-bootstrap-icons";
import { getBankAccount, getAllBankAccount, addEditBankAccount, dele, deleteBankAccount } from "../store/api/DocumentsAPI";
import { setDialog } from "../../store/api/CommonFunctions";
import { useDispatch } from "react-redux";

const ModalBankAccounts = (props) => {
    const { popData, setPopData } = props;
    const { Show, ForSelect } = popData;
    const searchPhrase = useRef("");
    const dispatch = useDispatch();
    const { handleSubmit, errors, register } = useForm();
    const [error, setError] = useState(null);
    const [currentRow, setCurrentRow] = useState(null);
    const [dataList, setDataList] = useState({ Data: [] });
    function close() {
        setPopData({
            Show: false
        })
        setCurrentRow(null);
        setError(null);
        searchPhrase.current = "";
    }
    const tableCols = [
        { colTitle: "نام بانک", colName: "BankName", showInMobile: true },
        { colTitle: "نام شعبه", colName: "BranchName", showInMobile: true },
        { colTitle: "شماره حساب", colName: "BankAccountNo", showInMobile: true },
        { colTitle: "کد حساب تفصیلی", colName: "AccountCode", showCondition: () => !ForSelect }
    ]
    const rowButtons = [];
    if (!ForSelect) {
        rowButtons.push(
            { type: "common", title: "ویرایش", className: "group-Btn-smalll", icon: <PencilFill color="orange" size={18} />, onclick: prepareForEdit },
            { type: "delete", title: "حذف", className: "group-Btn-smalll", onclick: deleteAcc }
        )
    }
    function prepareForAdd() {
        let accountCode = "1";
        if (dataList.Data?.length > 0) {
            const maxAccountCode = Math.max(...dataList.Data.map(d => Number(d.AccountCode)));
            const codeLength = dataList.Data.find(d => Number(d.AccountCode) === maxAccountCode).AccountCode.length;
            accountCode = (maxAccountCode + 1).toString().padStart(codeLength, "0");
        }
        setCurrentRow({
            ID: 0,
            AccountCode: accountCode
        })
    }
    function onSubmit(data) {
        setError(null);
        const onSuccess = (res) => {
            if (res.Data) {
                data.ID = res.Data;
                if (Number(currentRow.ID) === 0) {
                    dataList.Data.push(data);
                    setDataList({ ...dataList });
                }
                else if (Number(currentRow.ID) > 0) {
                    const account = dataList.Data.find(d => Number(d.ID) === Number(currentRow.ID));
                    Object.assign(account, data);
                    setDataList({ ...dataList });
                }
                setCurrentRow(null);
            }
            else if (res.Error) {
                setError(res.Error);
            }
        }
        addEditBankAccount(data, onSuccess)
    }
    function prepareForEdit(row) {
        const onSuccess = (res) => {
            if (res.Data) {
                setCurrentRow(res.Data);
            }
        }
        getBankAccount(row.ID, onSuccess);
    }
    function deleteAcc(item) {
        const onSuccess = (res) => {
            if (res.Error) {
                setError(res.Error);
            }
            else if (res === "success") {
                dataList.Data = dataList.Data.filter(d => Number(d.ID) !== Number(item.ID));
                setDataList({ ...dataList });
            }
        }
        dispatch(setDialog({
            status: 'show',
            arrayBtn: ['yes', 'no'],
            dialogTitle: 'حذف حساب',
            dialogText: 'آیا از حذف مطمئن هستید؟',
            okOperation: deleteBankAccount(item.ID, onSuccess)
        }))
    }
    function cancel() {
        setCurrentRow(null);
    }
    function search(e) {
        if (e.key && e.key !== "Enter") {
            return;
        }
        getAllBankAccount(searchPhrase.current, setDataList);
    }
    useEffect(() => {
        if (Show) {
            getAllBankAccount("", setDataList);
        }
    }, [Show])
    return (
        <Modal show={Show} onHide={() => { }}>
            <Modal.Header className="headerStyle">
                <span>
                    <FontAwesomeIcon icon={faUniversity} size="lg" />&nbsp;
                    حساب های بانکی
                </span>
                <FontAwesomeIcon icon={faTimes} onClick={close} size="lg" />
            </Modal.Header>
            <Modal.Body className="bodyStyle">
                {currentRow && currentRow !== "PENDING" &&
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <Row className="rowBorder">
                            <input type="hidden" defaultValue={currentRow.ID} name="ID" ref={register({})} />
                            <Col md={6} className="form-group">
                                <label>نام بانک: </label><span style={{ color: "red" }}>*</span>
                                <Form.Control name="BankName" ref={register({ required: true })} defaultValue={currentRow.BankName} />
                                {errors?.BankName && <small className="errors">نام بانک الزامی است</small>}
                            </Col>
                            <Col md={6} className="form-group">
                                <label>نام شعبه: </label>
                                <Form.Control name="BranchName" ref={register({})} defaultValue={currentRow.BranchName} />
                            </Col>
                            <Col md={6} className="form-group">
                                <label>کد شعبه: </label>
                                <Form.Control name="BranchCode" ref={register({})} defaultValue={currentRow.BranchCode} />
                            </Col>
                            <Col md={6} className="form-group">
                                <label>شماره حساب: </label><span style={{ color: "red" }}>*</span>
                                <Form.Control name="BankAccountNo" ref={register({ required: true })} defaultValue={currentRow.BankAccountNo} />
                                {errors?.BankAccountNo && <small className="errors">شماره حساب الزامی است</small>}
                            </Col>
                            <Col md={6} className="form-group">
                                <label>نوع حساب: </label>
                                <select className="form-control" name="BankAccountType" ref={register({})}>
                                    <option value="">انتخاب کنید</option>
                                    <option value="پس انداز">پس انداز</option>
                                    <option value="جاری">جاری</option>
                                </select>
                            </Col>
                            <Col md={6} className="form-group">
                                <label>نام صاحب حساب: </label>
                                <Form.Control name="AccountOwner" ref={register({})} defaultValue={currentRow.AccountOwner} />
                            </Col>
                            <Col md={6} className="form-group">
                                <label>کد حساب تفصیلی:</label>
                                <Form.Control name="AccountCode" ref={register({ required: true })} defaultValue={currentRow.AccountCode} />
                                {errors?.AccountCode && <small className="errors">کد تفصیلی الزامی است</small>}
                            </Col>
                            <Col md={7} className="mt-2">
                                <Button className="group-Btn" variant="success" type="submit">
                                    {Number(currentRow.ID) > 0 &&
                                        <Fragment>
                                            <Pencil size={18} />&nbsp; ویرایش
                                        </Fragment>
                                    }
                                    {Number(currentRow.ID) === 0 &&
                                        <Fragment>
                                            <CheckLg size={15} />&nbsp; ثـبت&nbsp;
                                        </Fragment>
                                    }
                                </Button>
                                <Button className="group-Btn" onClick={cancel} variant="danger">
                                    <DashCircle size={17} />&nbsp; انصراف
                                </Button>
                            </Col>
                        </Row>
                    </form>
                }
                {error && <Alert variant="danger"><ExclamationTriangle size={18} />&nbsp;{error}
                    <FontAwesomeIcon icon={faTimes} style={{ float: "left" }} onClick={() => setError(null)} />
                </Alert>}
                {!currentRow && !ForSelect && <PlusSquareFill color="purple" className="hoverIcon" size={23} onClick={prepareForAdd} />}
                {!currentRow && <FormGroup>
                    <Form.Control placeholder="جستجو کنید(نام بانک * نام شعبه * شماره حساب)"
                        onChange={e => searchPhrase.current = e.target.value} onKeyDown={search} />
                    <Button className="btn-input-tiny" style={{ top: "2px", left: "3px" }} onClick={search}><Search size={23} /></Button>
                </FormGroup>
                }
                <BihamtaTable className="mt-1" columns={tableCols} rowButtons={rowButtons} dataList={dataList} />
            </Modal.Body>
        </Modal>
    )

}
export default ModalBankAccounts;